module.exports = __webpack_public_path__ + "img/billing_bottom_banner_img.7a4dd715.svg";